import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
const SOLID_LOGO = "/logo-full.png";

const SLIDES = [
  "https://static.prod-images.emergentagent.com/jobs/a0323fc5-7f57-4625-b860-073d0f8b9fc9/images/620799c90a31f79f1eb30458877cb38c73fbc6f69fcf301c1424239cd2200323.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/a0323fc5-7f57-4625-b860-073d0f8b9fc9/images/f74e15143d0746ff39701600a0f75cb2a4e88bf9a0c0f5e3c24cf48b6230f5d9.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/a0323fc5-7f57-4625-b860-073d0f8b9fc9/images/9046018630f9ab56c13006e67986b1b2dd309d9027335e814554b28f30fd38e6.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/a0323fc5-7f57-4625-b860-073d0f8b9fc9/images/8ddac227a59a609dffbeddd6a07df17e7d87884761ef89b14aa6c0da86961795.jpeg",
];

// Set to a hosted .mp4 URL to play a welcome video after the visitor clicks Enter
const WELCOME_VIDEO_URL = null;

export const IntroGate = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(() => pathname === "/" && !sessionStorage.getItem("hfpa_intro_seen"));
  const [slide, setSlide] = useState(0);
  const [phase, setPhase] = useState(0); // 0 slides only, 1 logo, 2 welcome + enter, 3 video

  const dismiss = () => {
    sessionStorage.setItem("hfpa_intro_seen", "1");
    setShow(false);
    document.body.style.overflow = "";
  };

  const enter = () => {
    if (WELCOME_VIDEO_URL) {
      setPhase(3);
    } else {
      dismiss();
    }
  };

  useEffect(() => {
    if (!show || phase === 3) return;
    document.body.style.overflow = "hidden";
    const slideTimer = setInterval(() => setSlide((s) => (s + 1) % SLIDES.length), 2400);
    const t1 = setTimeout(() => setPhase(1), 1800);
    const t2 = setTimeout(() => setPhase(2), 3200);
    return () => {
      clearInterval(slideTimer);
      clearTimeout(t1);
      clearTimeout(t2);
      document.body.style.overflow = "";
    };
  }, [show]);



  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-overlay"
          exit={{ opacity: 0, transition: { duration: 1 } }}
          className="fixed inset-0 z-[200] overflow-hidden bg-black"
        >
          {phase === 3 ? (
            <div className="relative h-full w-full" data-testid="intro-video-phase">
              <video
                src={WELCOME_VIDEO_URL}
                autoPlay
                playsInline
                onEnded={dismiss}
                data-testid="intro-video"
                className="absolute inset-0 h-full w-full object-contain bg-black"
              />
              <button
                onClick={dismiss}
                data-testid="intro-skip-btn"
                className="absolute bottom-8 right-8 z-10 inline-flex items-center rounded-full border border-white/30 bg-black/50 backdrop-blur px-7 py-3 font-body text-sm tracking-[0.2em] uppercase text-white hover:border-[#d4af37] hover:text-[#fcf6ba] transition-colors duration-300"
              >
                Skip →
              </button>
            </div>
          ) : (
          <>
          {/* slideshow */}
          <AnimatePresence>
            <motion.img
              key={slide}
              src={SLIDES[slide]}
              alt=""
              initial={{ opacity: 0, scale: 1.08 }}
              animate={{ opacity: 0.55, scale: 1.16 }}
              exit={{ opacity: 0 }}
              transition={{ opacity: { duration: 1.4 }, scale: { duration: 3.4, ease: "linear" } }}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </AnimatePresence>
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/85" />

          {/* logo + welcome */}
          <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
            <AnimatePresence>
              {phase >= 1 && (
                <motion.img
                  src={SOLID_LOGO}
                  alt="Heritage Family Protection Agency crest"
                  initial={{ opacity: 0, scale: 0.85, y: 14 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                  className="w-[86vw] max-w-xl md:max-w-2xl h-auto object-contain glow-gold"
                />
              )}
            </AnimatePresence>
            <AnimatePresence>
              {phase >= 2 && (
                <motion.div
                  initial={{ opacity: 0, y: 18 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                  className="mt-2 flex flex-col items-center"
                >
                  <p className="font-body text-xs md:text-sm tracking-[0.4em] uppercase text-[#d4af37]" data-testid="intro-welcome-text">Welcome</p>
                  <motion.button
                    onClick={enter}
                    data-testid="intro-enter-btn"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                    className="btn-sweep mt-10 inline-flex items-center rounded-full bg-gold-metallic px-12 py-4 font-body text-sm font-semibold tracking-[0.25em] uppercase text-black"
                  >
                    Enter
                  </motion.button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          </>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
